const PageHeader = ({ title, subtitle, image }) => (
  <section className="page-header" style={{ backgroundImage: `url(${image})` }}>
    <div className="container page-header-content">
      <h1>{title}</h1>
      <p>{subtitle}</p>
    </div>
  </section>
);

export default PageHeader;